import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    paddingInline: 12,
    paddingBlock: 12,
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    paddingBlockEnd: 4,
    '& .MuiSvgIcon-root': {
      color: '#ADB6C8',
      display: 'flex',
    },
  },
  label: {
    '& .MuiTypography-root': {
      color: '#ADB6C8',
      fontWeight: 500,
      paddingBlockEnd: 4,
      textAlign: 'center',
    },
  },
  btn: {
    display: 'flex',
    justifyContent: 'center',
    '& .MuiTypography-root': {
      color: '#26AFFB',
      fontWeight: 500,
      paddingInlineStart: 4,
      textAlign: 'center',
      cursor: 'pointer',
      display: 'inline-flex',
    },
  },
}))

export default useStyles
